export default __webpack_public_path__ + "static/media/logo-faciliti-FR- (2).79b7a773.svg";